import { Tooltip } from 'antd'
import { isNil } from 'ramda'
import $t from '../../../../i18n'
import {
  getCopayAndNetworkCopay,
  getTextAfterCopay
} from '../../../../utils/hmoUtils'

import './ProviderCopay.css'

const ProviderCopay = ({
  planDetailsCopay,
  provider,
  useDefaultTextAfterCopayPrice = true,
  tooltipColor = 'var(--color_primary_t600)'
}) => {
  const { copay, networkCopay } = getCopayAndNetworkCopay({
    planDetailsCopay,
    provider
  })

  if (isNil(copay)) {
    return null
  }

  return (
    <div className='copay-container'>
      <div className='copay'>
        <span className='semi-bold'>
          {networkCopay?.isCopayMinRate && !provider?.is_antidote
            ? $t('providerPage.providerDetails.copayMin', { copay })
            : '$' + copay}
        </span>
        <span>
          {getTextAfterCopay({
            planDetailsCopay,
            provider,
            useDefaultText: useDefaultTextAfterCopayPrice
          })}
        </span>
        {networkCopay?.isCopayMinRate && !provider?.is_antidote && (
          <Tooltip
            title={$t('providerPage.providerDetails.copayNote', {
              copay: networkCopay?.copayMaxRate
            })}
            placement='bottom'
            color={tooltipColor}
          >
            <i className='icon-info'></i>
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default ProviderCopay
